import React from 'react';
import { WorkOrderPanel } from '../../../../enums/workOrderView';
import { PANEL_TABS } from '../constants';
import styles from './WorkOrderPanels.module.scss';

interface PanelSelectorProps {
  activePanel: WorkOrderPanel;
  onPanelChange: (panel: WorkOrderPanel) => void;
}

const PanelSelector = ({ activePanel, onPanelChange }: PanelSelectorProps) => {
  const handleTabClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPanelChange(event.currentTarget.dataset.panel as WorkOrderPanel);
  };

  return (
    <div className={styles.panelSelector} role="tablist" aria-label="Work order views">
      {PANEL_TABS.map(({ panel, label }) => (
        <button
          key={panel}
          type="button"
          role="tab"
          data-panel={panel}
          aria-selected={activePanel === panel}
          aria-controls={`work-order-panel-${panel}`}
          className={`${styles.panelSelectorTab} ${activePanel === panel ? styles.panelSelectorTabActive : ''}`}
          onClick={handleTabClick}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default React.memo(PanelSelector);
